import type { RosaElementsMapper } from './types';

export enum RosaElementEnum {
	MOUSE_LINE_SHOULDER = 'mouse_line_shoulder',
	ARM_ABDUCTION = 'arm_abduction',
	GRIPPER_GRIP_MOUSE = 'gripper_grip_mouse',
	WRIST_REST = 'wrist_rest',
	MOUSE_KEYBOARD_DIFFERENT_SURFACES = 'mouse_keyboard_different_surfaces',
	KNEES_MORE_THAN_NINETY = 'knees_more_than_ninety',
	KNEES_NINETY = 'knees_ninety',
	NO_FOOT_CONTACT = 'no_foot_contact',
	KNEES_LESS_THAN_NINETY = 'knees_less_than_ninety',
	NOT_ADJUSTABLE = 'not_adjustable',
	NO_LEG_MOBILITY = 'no_leg_mobility',
	HEADPHONES = 'headphones',
	TOO_FAR = 'too_far',
	NO_HANDS = 'no_hands',
	HOLDING_WITH_NECK = 'holding_with_neck',
	SCREEN_EYE_LEVEL = 'screen_eye_level',
	VERY_HIGH = 'very_high',
	VERY_LOW = 'very_low',
	NO_DOCUMENT_HOLDERS = 'no_document_holders',
	GLARE_ON_SCREEN = 'glare_on_screen',
	NECK_ROTATED = 'neck_rotated',
	FAR_AWAY = 'far_away',
	WRISTS_STRAIGHT = 'wrists_strainght',
	WRISTS_EXTENDED = 'wrists_extended',
	KEYBOARD_TOO_HIGH = 'keyboard_too_high',
	OBJECTS_OVERHEAD = 'objects_overhead',
	NON_ADJUSTABLE = 'non_adjustable',
	WRIST_DEVIATION = 'wrist_deviation',
	SHOULDERS_SHRUGGED = 'shoulders_shrugged',
	SHOULDERS_RELAXED = 'shoulders_relaxed',
	VERY_WIDE = 'very_wide',
	VERY_DAMAGED_SURFACE = 'very_damaged_surface',
	SPACE_MORE_THAN_EIGHT = 'space_more_than_eight',
	SPACE_BETWEEN_KNEE_SEAT = 'space_between_knee_seat',
	SPACE_LESS_THAN_EIGHT = 'space_less_than_eight',
	NO_LUMBAR_SUPPORT = 'no_lumbar_support',
	ADEQUATE_LUMBAR_SUPPORT = 'adequate_lumbar_support',
	BACKREST_FAR_BACK_FORWARD = 'backrest_far_back_forward',
	NON_BACKREST_LUMBAR_SUPPORT = 'non_backrest_lumbar_support',
	HIGH_WORK_SURFACE = 'high_work_surface'
}

export enum RosaSubCategoryEnum {
	CHAIR_HEIGHT = 'chair_height',
	ARMRESTS = 'armrests',
	SEAT_DEPTH = 'seat_depth',
	SEAT_BACKREST = 'seat_backrest',
	PHONE = 'phone',
	MONITOR = 'monitor',
	MOUSE = 'mouse',
	KEYBOARD = 'keyboard'
}

export enum RosaCategoryEnum {
	CHAIR = 'chair',
	MONITOR_PHONE = 'monitor_phone',
	MOUSE_KEYBOARD = 'mouse_keyboard'
}

export const ROSA_CATEGORY_LABELS = {
	[RosaCategoryEnum.CHAIR]: 'Chair',
	[RosaCategoryEnum.MONITOR_PHONE]: 'Monitor and Phone',
	[RosaCategoryEnum.MOUSE_KEYBOARD]: 'Mouse and Keyboard'
};

export const ROSA_SUBCATEGORY_LABELS = {
	[RosaSubCategoryEnum.CHAIR_HEIGHT]: 'Chair Height',
	[RosaSubCategoryEnum.ARMRESTS]: 'Armrests',
	[RosaSubCategoryEnum.SEAT_DEPTH]: 'Seat Depth',
	[RosaSubCategoryEnum.SEAT_BACKREST]: 'Seat Backrest',
	[RosaSubCategoryEnum.PHONE]: 'Phone',
	[RosaSubCategoryEnum.MONITOR]: 'Monitor',
	[RosaSubCategoryEnum.MOUSE]: 'Mouse',
	[RosaSubCategoryEnum.KEYBOARD]: 'Keyboard'
};

export const ROSA_ELEMENTS_MAPPER: RosaElementsMapper = {
	[RosaCategoryEnum.CHAIR]: {
		sub_categories: [
			RosaSubCategoryEnum.CHAIR_HEIGHT,
			RosaSubCategoryEnum.SEAT_DEPTH,
			RosaSubCategoryEnum.ARMRESTS,
			RosaSubCategoryEnum.SEAT_BACKREST
		]
	},
	[RosaCategoryEnum.MONITOR_PHONE]: {
		sub_categories: [RosaSubCategoryEnum.MONITOR, RosaSubCategoryEnum.PHONE]
	},
	[RosaCategoryEnum.MOUSE_KEYBOARD]: {
		sub_categories: [RosaSubCategoryEnum.MOUSE, RosaSubCategoryEnum.KEYBOARD]
	}
};
